<template>
  <span>
    <template v-if="isLocked">
      -
    </template>
    <template v-else-if="($store.getters.getPackage != 'premium' || isCoachlab) && value">
      <!-- <div class="label label-info" style="padding: 3px 15px;display: inline-block">
        {{ $t('premium') }}
      </div> -->
      <v-premium-lock :inline="true"></v-premium-lock>
    </template>
    <template v-else-if="$store.getters.getPackage == 'premium' && !isCoachlab && value">
      <slot></slot>
    </template>
    <template v-else>-</template>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['value', 'isLocked'],
  computed: {
    ...mapGetters(['selectedBot', 'isCoachlab'])
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/CustomerItemValue.vue